import { render, staticRenderFns } from "./addPagePurPay.vue?vue&type=template&id=f122cdfc&scoped=true&"
import script from "./addPagePurPay.vue?vue&type=script&lang=js&"
export * from "./addPagePurPay.vue?vue&type=script&lang=js&"
import style0 from "./addPagePurPay.vue?vue&type=style&index=0&id=f122cdfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f122cdfc",
  null
  
)

export default component.exports